export default __webpack_public_path__ + "static/carousel2-d83a95a6dba8b08a030ca241dfba2863.png";